import { render, staticRenderFns } from "./create-fulfilment.vue?vue&type=template&id=3a14fade&"
import script from "./create-fulfilment.vue?vue&type=script&lang=js&"
export * from "./create-fulfilment.vue?vue&type=script&lang=js&"
import style0 from "./create-fulfilment.vue?vue&type=style&index=0&id=3a14fade&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports